import { render, staticRenderFns } from "./HomeTabs.vue?vue&type=template&id=6ed3b5e0&"
import script from "./HomeTabs.vue?vue&type=script&lang=js&"
export * from "./HomeTabs.vue?vue&type=script&lang=js&"
import style0 from "./HomeTabs.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports